import React from "react";
import { TOPUP_CALLABLE_TIMEOUT_MS } from "./funds";
import { useCallableWaitCountdown } from "./useCallableWaitCountdown";
import { useTopupStrings } from "../Order/topup-strings";

/**
 * Content for `LoadingSpinner` `belowLoader` prop: short messages + optional countdowns
 * while long-running callables run. Add more named exports here (e.g. place-order, cancel).
 */

/** Full-screen spinner footer while the `topUp` callable runs (matches `TOPUP_CALLABLE_TIMEOUT_MS`). */
export function TopUpProgressBelowLoader({ active }: { active: boolean }) {
    const topupStrings = useTopupStrings();
    const sec = useCallableWaitCountdown(active, TOPUP_CALLABLE_TIMEOUT_MS);
    return (
        <div className="loader-below">
            <p className="loader-below-line">{topupStrings.topUpConnectingPayment}</p>
            <p className="loader-below-line loader-below-countdown">{topupStrings.topUpWaitSecondsLeft(sec)}</p>
        </div>
    );
}
